import { render, staticRenderFns } from "./BxGTIN.vue?vue&type=template&id=222c57b3&"
import script from "./BxGTIN.vue?vue&type=script&lang=js&"
export * from "./BxGTIN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports